var render = function render(){var _vm=this,_c=_vm._self._c;return _c('device-widget',{attrs:{"status":_vm.level,"name":"Light","node":_vm.node}})
}
var staticRenderFns = []

export { render, staticRenderFns }